<section class="skill-section">
  <div class="container my-4">
    <div class="row align-items-center justify-content-center">
      <div class="col-lg-6 col-md-10" *transloco="let t; read: 'home'">
        <!-- Skill Text Block -->
        <div class="skill-text">
          <div class="section-title mb-40 left-border">
            <!-- <span class="title-tag">Company Skills</span> -->
            <h2 class="title">{{ t("skil_title") }}</h2>
          </div>
          <p>
            {{ t("skil_text") }}
          </p>
        </div>
      </div>
      <div class="col-lg-6 col-md-10 m-auto">
        <img
          src="assets/img/illustration/02.png"
          width="100%"
          data-aos="fade-left"
        />
      </div>
    </div>
  </div>
</section>
